import React, { useState } from 'react';
import { UsersIcon } from '@heroicons/react/24/outline';
import useRouter from '../../hooks/useRouter';
import Urls from '../offer-create/Urls';
import DataCard from '../profile-edit/DataCard';
import { PayloadStates } from '@lore/utils';
import useOfferTags from '../../hooks/useOfferTags';
import TagTypes from '../../constants/TagTypes';
import usePageRouter from '../../dialogs-routable/_hooks/usePageRouter';

export default function StudentGroups(props) {
  const { offer } = props;

  const { history } = usePageRouter();

  const [timestamp] = useState(new Date().toISOString());

  const offerGroups = useOfferTags(offer, TagTypes.Group, timestamp);

  let subtitle = '';

  if (offerGroups.state === PayloadStates.FETCHING) {
    subtitle = '...';
  } else {
    subtitle = offerGroups.data.map(function(offerGroup) {
      return offerGroup.data.name;
    }).join(', ');
  }

  return (
    <DataCard
      title="Student Groups"
      icon={UsersIcon}
      subtitle={subtitle || '(not provided)'}
      onClick={() => history.push(Urls(offer).STUDENT_GROUPS)}
    />
  );
};
